export const productName = 'MEGAPACK BIBLIOTECOLOGÍA LISTO™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/pH8TLyyWiVeKdt5i9pUHxm/MOCKUP.png';

export const checkoutUrl = 'https://megapack-bibliotecologia-listo.impultienda.ar/checkout';

export const price = '$19.990 ARS';
export const priceBefore = '$72.000 ARS';

export const baseItems = [
  'TOMO 1: Fundamentos y Rol de la Biblioteca Escolar',
  'TOMO 2: Gestión y Organización de la Biblioteca Escolar',
  'TOMO 3: Organización Documental, Catalogación y Clasificación',
  'TOMO 4: Promoción y Mediación de la Lectura',
  'TOMO 5: Alfabetización Informacional y Ciudadanía Digital',
  'TOMO 6: Planificación, Proyectos y Gestión Pedagógica',
  'BONO 1: Banco de 100 Proyectos de Biblioteca Escolar Listos para Adaptar',
  'BONO 2: 100 Recursos y Herramientas para la Gestión Bibliotecaria',
  'BONO 3: 100 Propuestas de Animación y Promoción de la Lectura',
  'BONO 4: Calendario Bibliotecario 2026 — Efemérides, Campañas y Propuestas Mes a Mes',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const checklist: Array<[string, string]> = [
  ['Contenido 100% argentino', 'Normativas IFLA, leyes educativas vigentes, políticas de biblioteca escolar, contexto de inclusión digital en Argentina y casos de bibliotecas reales.'],
  ['Material imprimible', 'Listo para usar en el aula o entregar directamente al alumno.'],
  ['Formularios y plantillas reales', 'Proyectos, presupuestos, catalogación y propuestas de mediación adaptados a Argentina 2026.'],
  ['Casos prácticos resueltos paso a paso', 'Con datos reales del campo de la bibliotecología escolar argentina.'],
  ['Vocabulario técnico explicado', 'Sin jerga innecesaria, accesible para todos los niveles.'],
  ['Conexión con la actualidad', 'IA en búsqueda bibliográfica, lectura digital, ciudadanía digital, inclusión y accesibilidad.'],
  ['Historia y contexto argentino', 'Desde los orígenes de las bibliotecas escolares hasta las tendencias 2026.'],
  ['4 bonos estratégicos', 'Proyectos, recursos, actividades y calendario completo.'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios.'],
  ['Acceso inmediato', 'Descarga directa tras la compra.'],
  ['Actualizaciones gratuitas', 'Acceso de por vida al material.'],
];
